import $ from 'jquery';

$(document).ready(function () {
  acfCategorySliderBlock();
});

function acfCategorySliderBlock() {
  $('.featuredSlider').slick({
    centerMode: false,
    variableWidth: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    infinite: true,
    dots: false,
    prevArrow: `<button class="slick-prev" aria-label="Previous" type="button">
                  <svg width="36px" height="52px" viewBox="0 0 36 52" xmlns="http://www.w3.org/2000/svg" fill="#322B29" fill-opacity="0.16">
                    <polygon points="36 0 12.4076253 26.0007528 36 52 23.4988254 52 0 26.0007528 23.4988254 0"></polygon>
                  </svg>
                </button>`,
    nextArrow: `<button class="slick-next" aria-label="Next" type="button">
                  <svg width="36px" height="52px" viewBox="0 0 36 52" xmlns="http://www.w3.org/2000/svg" fill="#322B29" fill-opacity="0.16">
                    <polygon points="0 0 23.5923747 25.9992472 0 52 12.5011746 52 36 25.9992472 12.5011746 0"></polygon>
                  </svg>
                </button>`,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          centerMode: false,
          slidesToScroll: 1,
          slidesToShow: 1
        }
      }
    ]
  });
}

